import * as yup from "yup";

export default yup.object().shape({
  title: yup.string().required("Title is required"),
  category_id: yup.string().required("Category is required"),
  message: yup.string().required("Message is required"),
  attachment: yup.mixed().test("fileSize", "File size is too big ( max: 5 Megabytes )", (value) => {
    if (value) {
      return value.size < 5242880;
    }
    return true;
  }).test("fileType", "File type is not supported", (value) => {
    if (value) {
      return value.type === "image/jpeg" || value.type === "image/png" || value.type === "image/jpg";
    }
    return true;
  }),
});
